import React, { useState } from 'react';
import ReactSVG from 'react-svg';
import { FormattedHTMLMessage } from 'react-intl';
import { ShareViaEmailModal, ShareViaSmsModal, NeuroMessage, useNeuroMessages } from "@ignitesales/neuro-application";
import commonUI from "../utils/commonUI.jsx";

const HeaderMenu = ({showContactForm}) => {
    const componentClass = 'header-menu';
    const [showEmailModal, setEmailModalView] = useState(false);
    const [showSmsModal, setSmsModalView] = useState(false);
    const { formatIntlMessage } = useNeuroMessages();

    const goToLocationPage = () => {
        window.open(formatIntlMessage({ id: 'socialActions.visitABranch.link' }));
    }

    return (<div className={componentClass} id="headerMenu">
        <div className={`${componentClass}__actions`}>
            <button className={`${componentClass}__action visit-a-branch`} onClick={() => goToLocationPage()}>
                <NeuroMessage id="socialActions.visitABranch" />
                <ReactSVG src={'/classpath/assets/images/marker-white.svg'} />
            </button>
            <button className={`${componentClass}__action contact-me`} disabled onClick={() => showContactForm()} >
                <NeuroMessage id="socialActions.contactMe" />
                <ReactSVG src={'/classpath/assets/images/mail-white.svg'}/>
            </button>
            <button className={`${componentClass}__action email`} onClick={() => setEmailModalView(true)}>
                <NeuroMessage id="socialActions.email" />
                <ReactSVG src={'/classpath/assets/images/copy-white.svg'} />
            </button>
            <button className={`${componentClass}__action sms`} onClick={() => setSmsModalView(true)}>
                <NeuroMessage id="socialActions.sms" />
                <ReactSVG src={'/classpath/assets/images/smartphone-white.svg'} />
            </button>
            <button className={`${componentClass}__action phone`}>
                <FormattedHTMLMessage id={'headerMenu.phoneLink'} />
                <ReactSVG src={'/classpath/assets/images/phone-white.svg'} />
            </button>
        </div>
        <div className="logoWaves">
            <ReactSVG src={'/classpath/assets/images/waves.svg'} />
        </div>
        <ShareViaEmailModal closeBtn={commonUI.closeButton} isOpen={showEmailModal} onClose={() => setEmailModalView(false)} className="modal--shareViaEmail" />
        <ShareViaSmsModal closeBtn={commonUI.closeButton} isOpen={showSmsModal} onClose={() => setSmsModalView(false)} className="modal--shareViaSms" />
    </div>)
}

export default HeaderMenu;

